// Aviso discreto de nueva versión. Comprueba al iniciar, al volver a primer plano, cada 30 minutos y al cambiar
// de pantalla (como máximo cada 5 minutos). Nunca recarga solo: el usuario decide, y si hay cambios sin guardar
// se le pide confirmación. Actualizar no cierra sesión: tras recargar se restaura token → perfil → sucursal → menú.
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { versionPublicada, compararVersion, hayCambiosSinGuardar, recargarAplicacion, retirarServiceWorkers, VERSION_ACTUAL } from '../../services/version';
import { diag } from '../../services/diagnostico';
import './AvisoVersion.css';

const CADA_MS = 30 * 60 * 1000;
const MIN_ENTRE_CONSULTAS_MS = 5 * 60 * 1000;

export default function AvisoVersion() {
  const [estado, setEstado] = useState('igual'); // 'igual' | 'nueva' | 'obligatoria'
  const ultima = useRef(0);
  const location = useLocation();

  const comprobar = useCallback(async ({ forzar = false } = {}) => {
    if (!forzar && Date.now() - ultima.current < MIN_ENTRE_CONSULTAS_MS) return;
    ultima.current = Date.now();
    const pub = await versionPublicada();
    const r = compararVersion(pub);
    if (r === 'nueva' || r === 'obligatoria') {
      diag('version', 'versión nueva publicada', { actual: VERSION_ACTUAL, publicada: pub.version, obligatoria: r === 'obligatoria' });
      setEstado(r);
    }
  }, []);

  useEffect(() => {
    retirarServiceWorkers();
    comprobar({ forzar: true });
    const visible = () => { if (document.visibilityState === 'visible') comprobar({ forzar: true }); };
    document.addEventListener('visibilitychange', visible);
    const t = setInterval(() => comprobar({ forzar: true }), CADA_MS);
    return () => { document.removeEventListener('visibilitychange', visible); clearInterval(t); };
  }, [comprobar]);
  useEffect(() => { comprobar(); }, [location.pathname, comprobar]);

  const actualizar = async () => {
    if (hayCambiosSinGuardar()) {
      const r = await Swal.fire({ icon: 'warning', title: 'Tienes cambios sin guardar', text: 'Guárdalos antes de actualizar o se perderán.',
        showCancelButton: true, confirmButtonText: 'Actualizar de todos modos', cancelButtonText: 'Seguir trabajando' });
      if (!r.isConfirmed) return;
    }
    recargarAplicacion();
  };

  if (estado === 'igual') return null;
  return (
    <div className={`aviso-version${estado === 'obligatoria' ? ' aviso-version--obligatoria' : ''}`} role="status" aria-live="polite">
      <div>
        <b>{estado === 'obligatoria' ? 'El sistema fue actualizado.' : 'Nueva versión disponible'}</b>
        <span>{estado === 'obligatoria' ? 'Es necesario recargar la aplicación.' : 'Actualiza para obtener las últimas mejoras.'}</span>
      </div>
      <button type="button" onClick={actualizar}>Actualizar ahora</button>
    </div>
  );
}
